import {colors} from './colors'

export const themeConfig = {
    token: {
        // Font
        fontFamily: 'Poppins, serif',
        fontSize: 14,

        // Colors
        colorPrimary: colors.primary800,
        colorBgContainer: colors.white,
        colorBgLayout: colors.grey1,
        colorText: colors.dark,
        colorTextSecondary: colors.grey5,
        colorTextTertiary: colors.grey5,
        colorTextQuaternary: colors.grey6,
        colorLink: colors.primary800,
        colorLinkHover: colors.primary600,
        colorLinkActive: colors.primary600,

        // Border
        borderRadius: 12,

        // Shadows
        boxShadow: '0 4px 16px rgba(85, 88, 92, 0.08), inset 0px -1px 0px #edeef2',
        boxShadowSecondary: '0 6px 8px -4px rgb(85 88 92 / 24%)'
    },
    components: {
        Typography: {
            colorTextHeading: colors.dark,
            titleMarginTop: 0,
            colorLink: colors.primary800,
            colorLinkHover: colors.dark,
            linkHoverDecoration: 'none'
        },
        Button: {
            fontFamily: 'Poppins, serif',
            controlHeight: 40,
            controlHeightSM: 40,
            controlHeightLG: 50,
            borderRadius: 12,
            paddingContentHorizontal: 20,

            // Link button
            linkHoverBg: 'transparent',
            colorLink: colors.primary600,
            colorLinkHover: colors.primary600,
            colorLinkActive: colors.primary600,

            // Danger button
            colorError: colors.red5,
            colorErrorHover: colors.red5,
            colorErrorActive: colors.red5,

            // Disabled states
            colorTextDisabled: colors.grey3,
            borderColorDisabled: colors.grey3,
            colorBgContainerDisabled: colors.white,

            // Ghost button
            ghostBg: 'transparent'
        },
        Input: {
            controlHeight: 40,
            activeBorderColor: colors.primary600,
            hoverBorderColor: colors.primary300,
            activeShadow: `0 0 0 2px ${colors.primary100}`,
            errorActiveShadow: '0 0 0 2px rgba(234, 98, 98, 0.2)'
        },
        Select: {
            controlHeight: 40,
            borderRadius: 12,
            singleItemHeightLG: 50,
            optionSelectedBg: colors.primary100,
            optionActiveBg: colors.primary100,
            optionPadding: '5px 12px',
            optionHeight: 32,
            multipleItemBorderColor: 'transparent',
            multipleItemHeight: 24
        },
        DatePicker: {
            controlHeight: 40,
            cellHeight: 36,
            cellWidth: 36,
            cellActiveWithRangeBg: colors.primary100,
            cellRangeBorderColor: colors.primary100,
            cellBgDisabled: colors.grey2,
            cellHoverBg: colors.primary100
        },
        Radio: {
            size: 16,
            dotSize: 8,
            colorPrimary: colors.primary600,
            colorPrimaryHover: colors.primary600,
            colorPrimaryActive: colors.primary600,
            colorBorder: colors.grey3,
            colorBgContainer: colors.white,
            buttonSolidCheckedBg: colors.primary600
        },
        Checkbox: {
            size: 16,
            borderRadius: 2,
            colorPrimary: colors.primary800,
            colorPrimaryHover: colors.primary600,
            colorBorder: colors.grey3,
            colorBgContainer: colors.white
        },
        Switch: {
            trackHeight: 25,
            trackMinWidth: 40,
            handleSize: 20,
            colorPrimary: colors.primary800,
            colorPrimaryHover: colors.primary600
        },
        // Modal: {
        //     borderRadius: 12,
        //     padding: 24,
        //     paddingContentHorizontal: 24,
        //     paddingLG: 24
        // },
        Card: {
            padding: 0,
            paddingLG: 24,
            headerHeight: 48,
            headerPadding: 16
        },
        Table: {
            headerBg: colors.grey1,
            borderColor: colors.grey6
        },
        Tag: {
            defaultBg: colors.grey2,
            defaultColor: colors.dark,
            borderRadius: 12,
            lineWidth: 0
        },
        Tabs: {
            verticalItemMargin: '0',
            horizontalMargin: '0 0 0 16px',
            itemActiveColor: colors.primary800,
            itemHoverColor: colors.primary800,
            itemSelectedColor: colors.primary800,
            inkBarColor: colors.primary800
        },
        Pagination: {
            itemActiveBg: colors.white,
            itemLinkBg: colors.white,
            colorText: colors.dark,
            colorTextDisabled: colors.grey3,
            colorPrimary: colors.primary800,
            colorPrimaryHover: colors.primary800
        },
        Progress: {
            defaultColor: colors.secondary
        },
        Carousel: {
            dotWidth: 8,
            dotHeight: 8,
            dotActiveWidth: 8
        },
        Collapse: {
            headerPadding: '12px 0',
            contentPadding: '16px 0',
            borderRadius: 0
        },
        List: {
            itemPadding: '12px 0',
            metaMarginBottom: 16
        },
        Popover: {
            padding: 16,
            borderRadius: 12
        },
        Divider: {
            verticalMarginInline: 8,
            textPaddingInline: '0 8px'
        },
        Tooltip: {
            borderRadius: 8
        },
        Spin: {
            dotSize: 20,
            dotSizeSM: 14,
            dotSizeLG: 32
        },
        Dropdown: {
            paddingBlock: 4,
            borderRadius: 12,
            controlItemBgHover: colors.primary800,
            controlPaddingHorizontal: 12
        },
        Avatar: {
            borderRadius: 50,
            groupBorderColor: colors.white,
            containerSize: 40,
            containerSizeLG: 40,
            containerSizeSM: 32
        },
        Notification: {
            padding: 16,
            paddingLG: 20
        },
        Drawer: {
            padding: 24,
            paddingLG: 24
        }
    }
}
